'use client';

import { createContext } from 'react';

import type { ModalFloatingContextInterface } from '../types/use-modal.types';

export const ModalFloatingContext = createContext({} as ModalFloatingContextInterface);

ModalFloatingContext.displayName = 'Modal.Floating.Context';
